<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div class="ts-flex ts-space-x-3">
        <label class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md">{{
          $t('wholesale.item')
        }}</label>
        <a
          href="#"
          class="
            ts-shadow-rounded
            ts-uppercase
            ts-px-4
            ts-rounded-md
            ts-bg-blue-400
            ts-text-white
            ts-flex
            ts-items-center
            ts-no-underline
            hover:ts-no-underline
          "
          style="height: 31px"
          @click.prevent="getProductBalance"
        >
          <span class="ts-mr-2">{{ $t('saleContract.getBalance') }}</span>
          <i class="fas fa-balance-scale"></i>
        </a>
      </div>
      <AddAutoAfterSearchSerial v-model="model" @calculate="calculate" />
    </div>
    <div class="max-h">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-4
              "
            >
              {{ $t('wholesale.no') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-64
              "
            >
              {{ $t('wholesale.product') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-16
              "
            >
              {{ $t('wholesale.quantity') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-16
              "
            >
              {{ $t('wholesale.uom') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-20
              "
            >
              {{ $t('wholesale.upThb') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-20
              "
            >
              {{ $t('wholesale.unitPrice') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-12
              "
            >
              {{ $t('wholesale.discountType') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-12
              "
            >
              {{ $t('wholesale.discountRate') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-12
              "
            >
              {{ $t('wholesale.vatRate') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-10
              "
            >
              {{ $t('wholesale.isCutom') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-w-32
              "
            >
              {{ $t('wholesale.grandTotal') }}
            </th>
            <th
              class="
                ts-border
                ts-border-gray-300
                ts-uppercase
                ts-px-2
                ts-py-2
                ts-whitespace-no-wrap
                ts-text-center
                ts-w-20
              "
            >
              {{ $t('actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(product, index) in model.product_detail"
            :key="index"
            class="ts-border-b ts-border-gray-300"
          >
            <td class="ts-text-center">{{ index + 1 }}</td>
            <td
              class="ts-px-2 ts-py-1 ts-cursor-pointer"
              @click.prevent="showBalance(product)"
            >
              <a-popover :title="$t('wholesale.serial')" placement="bottomLeft">
                <template slot="content">
                  <p
                    v-for="(s, i) in product.serial_list"
                    :key="i"
                    class="ts-text-red-600"
                  >
                    {{ s.label }}
                  </p>
                </template>
                <p class="ts-mb-0 ts-font-extrabold ts-text-blue-600">
                  <i class="fab fa-product-hunt"></i>
                  {{ product.product_name_en }}
                </p>
                <p class="ts-mb-0">
                  <i class="fas fa-barcode"></i> {{ product.barcode }}
                </p>
                <p class="ts-mb-0">
                  <i class="fas fa-balance-scale"></i
                  ><b> {{ product.balance }}</b>
                </p>
              </a-popover>
              <div
                class="validate"
                v-if="errors.has('product_detail.' + index + '.serial_list')"
              >
                {{ errors.first('product_detail.' + index + '.serial_list') }}
              </div>
            </td>
            <td>
              <input
                v-model.number="product.quantity"
                type="number"
                class="form-control ts-text-center"
                :readonly="product.has_serial"
                @input="calculate()"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_detail.' + index + '.quantity')"
              >
                {{ errors.first('product_detail.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <a-select
                v-model.number="product.uom_id"
                class="ts-w-full"
                ref="uom"
                :class="{
                  'is-invalid': errors.has(
                    'product_detail.' + index + '.uom_id'
                  ),
                }"
                @change="onUomChange(product)"
              >
                <a-select-option
                  v-for="(u, index) in getUom(product.product_id)"
                  :key="index"
                  :value="u.uom_id"
                  >{{ u.uom_name_en }}
                </a-select-option>
              </a-select>
            </td>
            <td class="ts-w-32">
              <ts-currency-input
                v-model.number="product.amount_in_bath"
                currency="฿"
                class="form-control ts-text-right"
                @input="onThbInput(product)"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_detail.' + index + '.unit_price')"
              >
                {{ errors.first('product_detail.' + index + '.unit_price') }}
              </div>
            </td>
            <td class="ts-w-32">
              <ts-currency-input
                v-model.number="product.unit_price"
                class="form-control ts-text-right"
                @input="onUpUsdInput(product)"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_detail.' + index + '.unit_price')"
              >
                {{ errors.first('product_detail.' + index + '.unit_price') }}
              </div>
            </td>
            <td>
              <select
                class="form-control"
                ref="discountType"
                v-model="product.discount_type"
                @change="calculate(product)"
              >
                <option value="$">$</option>
                <option value="%">%</option>
              </select>
            </td>
            <td>
              <input
                v-model.number="product.discount_rate"
                type="text"
                ref="discountRate"
                class="form-control"
                @input="calculate()"
              />
            </td>
            <td>
              <input
                v-model.number="product.vat_rate"
                type="text"
                ref="vatRate"
                class="form-control"
                @input="calculate()"
                :readonly="product.vat_eligible"
              />
            </td>
            <td class="ts-text-center">
              <input v-model="product.is_custom" type="checkbox" />
            </td>
            <td>
              <ts-currency-input
                v-model="product.grand_total"
                class="
                  ts-border
                  ts-w-full
                  ts-border-gray-300
                  ts-rounded-sm
                  ts-p-2
                  ts-text-right
                  ts-outline-none
                  ts-font-extrabold
                "
                disabled
              />
            </td>
            <td class="ts-text-center ts-space-x-3">
              <a
                v-if="model.customer_id != null"
                href="#"
                class="ts-text-blue-700"
                @click.prevent="viewPrice(product)"
              >
                <i class="fa fa-dollar-sign ts-mt-2"></i>
              </a>
              <a
                href="#"
                class="ts-text-red-600"
                @click.prevent="removeRow(product)"
              >
                <i class="fa fa-trash"></i>
              </a>
              <a
                href="#"
                v-if="product.has_serial"
                @click.prevent="addSerialProduct(product)"
              >
                <i class="fas fa-list"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="ts-bg-blue-600" colspan="12"></td>
          </tr>
          <tr class="ts-bg-gray-300">
            <td
              class="ts-px-2 ts-py-1 ts-font-extrabold ts-uppercase"
              colspan="2"
            >
              <span>{{ $t('wholesale.rowNum') }} : </span
              >{{ $formatNumber(numRow) }}
            </td>
            <td
              class="
                ts-px-2 ts-py-1 ts-font-extrabold ts-text-red-600 ts-uppercase
              "
            >
              <span>{{ $t('wholesale.qty') }} : </span>
              {{ $formatNumber(countQty) }}
            </td>
            <td class="ts-text-right ts-px-2 ts-py-1" colspan="7">
              <span class="ts-font-extrabold ts-text-red-600 ts-uppercase"
                >{{ $t('wholesale.total') }} :
              </span>
            </td>
            <td class="ts-text-right ts-font-extrabold ts-text-red-600">
              <ts-currency-input
                class="
                  ts-w-full
                  ts-p-2
                  ts-text-right
                  ts-font-extrabold
                  ts-text-red-700
                  ts-outline-none
                  ts-bg-white
                "
                :value="totalAmountUSDPrice"
                disabled
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3" rowspan="5">
              <textarea
                v-model.trim="model.remark"
                rows="5"
                class="form-control"
                :placeholder="$t('wholesale.remark')"
              ></textarea>
            </td>
            <td colspan="7" class="ts-text-right">
              <div
                class="
                  ts-bg-blue-600
                  ts-text-white
                  ts-w-48
                  ts-float-right
                  ts-p-2
                  ts-rounded-sm
                  ts-uppercase
                "
              >
                <b>{{ $t('wholesale.discount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <ts-currency-input
                class="form-control ts-text-right"
                v-model.number="model.discount"
                @input="calculate"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="7" class="ts-text-right">
              <div
                class="
                  ts-bg-blue-600
                  ts-text-white
                  ts-w-48
                  ts-float-right
                  ts-p-2
                  ts-rounded-sm
                  ts-uppercase
                "
              >
                <b>{{ $t('wholesale.vatRate') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="number"
                class="form-control ts-text-right"
                v-model.number="model.vat_rate"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="7" class="ts-text-right">
              <div
                class="
                  ts-bg-blue-600
                  ts-text-white
                  ts-w-48
                  ts-float-right
                  ts-p-2
                  ts-rounded-sm
                  ts-uppercase
                "
              >
                <b>{{ $t('wholesale.vatAmount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <ts-currency-input
                class="
                  ts-text-right
                  ts-p-2
                  ts-border
                  ts-border-gray-300
                  ts-rounded
                  ts-w-full
                  ts-outline-none
                  ts-bg-white
                "
                :value="model.vat_amount"
                disabled
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="7" class="ts-text-right">
              <div
                class="
                  ts-bg-blue-600
                  ts-text-white
                  ts-w-48
                  ts-float-right
                  ts-p-2
                  ts-rounded-sm
                  ts-uppercase
                "
              >
                <b>{{ $t('wholesale.despositAmount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <ts-currency-input
                class="
                  ts-text-right
                  ts-p-2
                  ts-border
                  ts-border-gray-300
                  ts-rounded
                  ts-w-full
                  ts-outline-none
                  ts-bg-white
                "
                :value="model.amount_deposit"
                disabled
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="7" class="ts-text-right">
              <div
                class="
                  ts-bg-blue-600
                  ts-text-white
                  ts-w-48
                  ts-float-right
                  ts-p-2
                  ts-rounded-sm
                  ts-uppercase
                "
              >
                <b>{{ $t('wholesale.grandTotal') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <ts-currency-input
                class="
                  ts-text-right
                  ts-p-2
                  ts-w-full
                  ts-text-red-700
                  ts-font-extrabold
                  ts-border
                  ts-border-gray-400
                  ts-rounded-sm
                  ts-outline-none
                  ts-bg-white
                "
                :value="model.grand_total"
                disabled
              />
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <a-drawer
      v-if="show_serial_input"
      :title="addSerial.product_name_en"
      :width="400"
      :zIndex="1020"
      :visible="show_serial_input"
      :body-style="{ paddingBottom: '80px' }"
      @close="() => (show_serial_input = false)"
    >
      <AddProductSerialManual v-model="addSerial" @calculate="calculate" />
    </a-drawer>

    <a-modal
      v-if="show_price"
      v-model="show_price"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      width="500px"
      :title="
        selectedProduct
          ? selectedProduct.barcode + '|' + selectedProduct.product_name_en
          : 'N/A'
      "
    >
      <SoldPrice
        v-model="model"
        :product="selectedProduct"
        @priceChange="priceChange()"
      />
    </a-modal>

    <a-modal
      v-if="show_modal_balance"
      v-model="show_modal_balance"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      width="400px"
      :title="
        balanceOtherLocation.length > 0
          ? balanceOtherLocation[0].product_name_en
          : ''
      "
    >
      <div class="ts-space-y-3">
        <div
          class="ts-flex ts-justify-between ts-border-b"
          v-for="(b, index) in balanceOtherLocation"
          :key="index"
        >
          <div>
            {{ b.location_name }}
          </div>
          <div>
            {{ b.ending_balance }}
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapGetters } from 'vuex'
import AddProductSerialManual from './add-product-serial-manual.vue'
import AddAutoAfterSearchSerial from './auto-after-search-serial.vue'
import SoldPrice from './sold-price.vue'
export default {
  name: 'itemDetails',
  props: ['value', 'validate'],
  components: {
    AddProductSerialManual,
    AddAutoAfterSearchSerial,
    SoldPrice,
  },
  data() {
    return {
      errors: new Errors(),
      show_serial_input: false,
      show_modal_balance: false,
      show_price: false,
      balanceOtherLocation: [],
      selectedProduct: [],
      product_id: '',
      addSerial: {
        product_name_en: null,
      },
      model: {},
    }
  },
  computed: {
    ...mapGetters('wholesale/operation', ['getUom', 'getSalePrice']),
    numRow() {
      return this.model.product_detail.length
    },
    countQty() {
      return _.sumBy(this.model.product_detail, 'quantity')
    },
    sumUSDPrice() {
      return _.sumBy(this.model.product_detail, 'unit_price')
    },
    totalAmountUSDPrice() {
      return _.sumBy(this.model.product_detail, 'grand_total')
    },
    thbRate() {
      let foundFx = this.$store.state.wholesale.operation.exchangeRate.find(
        (e) => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }
      return 32
    },
    locationAssign() {
      return this.$store.state.authUser.user.warehouses
        .filter((w) => !w.pivot.is_default)
        .map((el) => el.location_id)
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('wholesale/operation', ['getFormViewData', 'productBalance']),
    removeRow(row) {
      this.model.product_detail.splice(
        this.model.product_detail.indexOf(row),
        1
      )
      this.calculate()
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
      this.calculate()
    },
    onThbInput(row) {
      row.unit_price = row.amount_in_bath / this.thbRate
      this.calculate()
    },
    onUpUsdInput(row) {
      row.amount_in_bath = row.unit_price * this.thbRate
      this.calculate()
    },
    calculate() {
      this.model.product_detail.forEach((detail) => {
        var amount = detail.unit_price * detail.quantity
        if (detail.discount_type == '$') {
          detail.discount_amount = detail.discount_rate
        }
        if (detail.discount_type == '%') {
          detail.discount_amount = (amount * detail.discount_rate) / 100
        }
        detail.total_after_discount = amount - detail.discount_amount
        detail.vat_rate = detail.vat_rate ? detail.vat_rate : 0
        detail.vat_amount =
          (detail.total_after_discount * detail.vat_rate) / 100
        detail.grand_total = detail.total_after_discount + detail.vat_amount
      })

      this.model.sub_total = _.sumBy(this.model.product_detail, 'grand_total')

      this.model.discount = this.model.discount ? this.model.discount : 0
      this.model.total_after_discount =
        this.model.sub_total - this.model.discount
      this.model.vat_rate = this.model.vat_rate ? this.model.vat_rate : 0
      this.model.vat_amount =
        this.model.total_after_discount * (this.model.vat_rate / 100)

      this.model.grand_total =
        this.model.total_after_discount +
        this.model.vat_amount -
        this.model.amount_deposit

      this.model.amount_paid = this.model.grand_total
      this.model.amount_due = 0
    },
    addSerialProduct(product) {
      this.addSerial = product
      this.show_serial_input = true
    },
    viewPrice(product) {
      this.show_price = true
      this.selectedProduct = product
      this.product_id = product.product_id
    },
    priceChange() {
      let row = this.model.product_detail.find(
        (e) => e.product_id == this.product_id
      )
      this.onUpUsdInput(row)
    },
    getProductBalance() {
      this.$emit('loading', true)
      var product = this.model.product_detail.map((el) => el.product_id)
      if (product.length) {
        this.$emit('loading', true)
        this.productBalance({
          product_id: product,
        })
          .then((response) => {
            let data = response.data
            this.model.product_detail.forEach(
              (el) =>
                (el.balance = data.find(
                  (p) => p.product_id == el.product_id
                ).ending_balance)
            )
          })
          .catch((error) => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      }
    },
    showBalance(record) {
      this.show_modal_balance = true
      this.$emit('loading', true)
      this.productBalance({
        product_id: [record.product_id],
        location_id: this.locationAssign,
      })
        .then((response) => {
          this.balanceOtherLocation = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>

<style scoped>
.max-h {
  height: 610px;
  max-height: 620px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  /* border-spacing: 0;  */
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}
</style>
